<template>
  <div class="masiva-upload">
    <el-button
      data-test="descargar-plantilla"
      :icon="IconDownload"
      :loading="descargando"
      @click="descargarPlantilla"
      >Descargar plantilla</el-button
    >
    <el-upload
      class="masiva-upload__uploader"
      :http-request="onPickFile"
      :show-file-list="false"
      accept=".xlsx"
    >
      <el-button
        type="primary"
        :icon="IconUpload"
        :loading="store.loading"
        >Subir archivo para validar</el-button
      >
    </el-upload>
    <span
      v-if="store.archivoNombre"
      class="masiva-upload__file"
      >{{ store.archivoNombre }}</span
    >
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { CotizacionMasivaService } from '@/services/cotizacion_masiva_service.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useCotizacionMasivaStore } from '../stores/cotizacion_masiva_store.js';
import { descargarBlob } from '../utils/descargar_blob.js';
import IconDownload from '~icons/mdi/download';
import IconUpload from '~icons/mdi/upload';

const NOMBRE_PLANTILLA = 'plantilla-cotizacion-masiva.xlsx';

const store = useCotizacionMasivaStore();
const descargando = ref(false);

const descargarPlantilla = async () => {
  descargando.value = true;
  try {
    const response = await CotizacionMasivaService.descargarPlantilla();
    descargarBlob(response.data, NOMBRE_PLANTILLA);
  } catch (error) {
    useMessageError().open('No se pudo descargar la plantilla.');
  } finally {
    descargando.value = false;
  }
};

const onPickFile = async ({ file }) => {
  if (!file.name.toLowerCase().endsWith('.xlsx')) {
    useMessageError().open('El archivo debe ser .xlsx');
    return;
  }
  try {
    await store.validarArchivo(file);
  } catch (error) {
    useMessageError().open(error?.response?.data?.message || 'No se pudo validar el archivo.');
  }
};
</script>

<style scoped>
.masiva-upload {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.masiva-upload__file {
  font-size: 13px;
  color: #6b7280;
}
</style>
